import SarasErpApi from '../../../helper/SarasErpApi';

const MONTH_RANGE_BEFORE = 12;
const MONTH_RANGE_AFTER = 12;
const PLAN_WEEK_ACTION_NAME = 'planWeek';

export const buildPlanWeekSaveSettingRequest = (documentTypeId, settingKey, settingValue) => ({
    actionName: PLAN_WEEK_ACTION_NAME,
    actionId: 'save',
    actionType: 'saveSetting',
    dataList: {
        dtId: documentTypeId,
        settingKey,
        settingValue
    }
});

export const buildPlanWeekDeleteSettingRequest = (documentTypeId, settingKey) => ({
    actionName: PLAN_WEEK_ACTION_NAME,
    actionId: 'save',
    actionType: 'deleteSetting',
    dataList: {
        dtId: documentTypeId,
        settingKey
    }
});

export const buildPlanWeekSaveChangesRequest = (documentTypeId, boardType, boardId, viewId, changeSort, changePlanDate) => ({
    actionName: PLAN_WEEK_ACTION_NAME,
    actionId: 'save',
    actionType: 'saveWeekChanges',
    dataList: {
        dtId: documentTypeId,
        boardType: boardType || '',
        boardId: boardId || 0,
        viewId: viewId || 0
    },
    changeSort: changeSort || [],
    changePlanDate: changePlanDate || []
});

export const buildPlanWeekRequestUnlockOtpRequest = (documentTypeId, otpReference) => ({
    actionName: PLAN_WEEK_ACTION_NAME,
    actionId: 'refresh',
    actionType: 'requestUnlockOtp',
    dataList: {
        dtId: documentTypeId,
        ulotpref: otpReference
    }
});

export const buildPlanWeekVerifyUnlockOtpRequest = (documentTypeId, otp, otpReference) => ({
    actionName: PLAN_WEEK_ACTION_NAME,
    actionId: 'refresh',
    actionType: 'verifyUnlockOtp',
    dataList: {
        dtId: documentTypeId,
        ulotp: otp,
        ulotpref: otpReference
    }
});

export const buildPlanWeekWeekSummaryRequest = (documentTypeId, searchResultsCriteria, weekEndDates) => ({
    actionName: PLAN_WEEK_ACTION_NAME,
    actionId: 'show',
    actionType: 'week-summary',
    dataList: {
        dtId: documentTypeId,
        searchResultsCriteria: searchResultsCriteria || ''
    },
    weekEndDates: weekEndDates || []
});

export const buildPlanWeekMonthSummaryRequest = (documentTypeId, searchResultsCriteria, monthKeys) => ({
    actionName: PLAN_WEEK_ACTION_NAME,
    actionId: 'show',
    actionType: 'month-summary',
    dataList: {
        dtId: documentTypeId,
        searchResultsCriteria: searchResultsCriteria || ''
    },
    monthKeys: monthKeys || []
});

export const savePlanWeekSetting = async (documentTypeId, settingKey, settingValue, onSuccessCallBack) => {
    const requestObject = buildPlanWeekSaveSettingRequest(documentTypeId, settingKey, settingValue);
    const response = await SarasErpApi.post('core', requestObject);

    if (onSuccessCallBack) onSuccessCallBack(response, requestObject);

    return response;
};

export const deletePlanWeekSetting = async (documentTypeId, settingKey, onSuccessCallBack) => {
    const requestObject = buildPlanWeekDeleteSettingRequest(documentTypeId, settingKey);
    const response = await SarasErpApi.post('core', requestObject);

    if (onSuccessCallBack) onSuccessCallBack(response, requestObject);

    return response;
};

export const savePlanWeekChanges = async (documentTypeId, boardType, boardId, viewId, changeSort, changePlanDate, onSuccessCallBack) => {
    const requestObject = buildPlanWeekSaveChangesRequest(documentTypeId, boardType, boardId, viewId, changeSort, changePlanDate);
    const response = await SarasErpApi.post('core', requestObject);

    if (onSuccessCallBack) onSuccessCallBack(response, requestObject);

    return response;
};

export const requestPlanWeekUnlockOtp = async (documentTypeId, otpReference, onSuccessCallBack) => {
    const requestObject = buildPlanWeekRequestUnlockOtpRequest(documentTypeId, otpReference);
    const response = await SarasErpApi.post('core', requestObject);

    if (onSuccessCallBack) onSuccessCallBack(response, requestObject);

    return response;
};

export const verifyPlanWeekUnlockOtp = async (documentTypeId, otp, otpReference, onSuccessCallBack) => {
    const requestObject = buildPlanWeekVerifyUnlockOtpRequest(documentTypeId, otp, otpReference);
    const response = await SarasErpApi.post('core', requestObject);

    if (onSuccessCallBack) onSuccessCallBack(response, requestObject);

    return response;
};

export const fetchPlanWeekSummary = async (documentTypeId, searchResultsCriteria, weekEndDates, onSuccessCallBack) => {
    const requestObject = buildPlanWeekWeekSummaryRequest(documentTypeId, searchResultsCriteria, weekEndDates);
    const response = await SarasErpApi.post('core', requestObject);

    if (onSuccessCallBack) onSuccessCallBack(response, requestObject);

    return response;
};

export const fetchPlanMonthSummary = async (documentTypeId, searchResultsCriteria, monthKeys, onSuccessCallBack) => {
    const requestObject = buildPlanWeekMonthSummaryRequest(documentTypeId, searchResultsCriteria, monthKeys);
    const response = await SarasErpApi.post('core', requestObject);

    if (onSuccessCallBack) onSuccessCallBack(response, requestObject);

    return response;
};

export const buildPlanWeekChangePayload = (dropResult, weeks, snapMode) => {
    if (!dropResult?.sourceRow || !dropResult?.destGroup) {
        return {
            changeSort: [],
            changePlanDate: []
        };
    }

    const changedStartIndex = dropResult.destGroup.changedStartIndex || 0;
    const changedRows = dropResult.destGroup.changedRows || [];
    const destRows = dropResult.destGroup.rows || [];
    const previousRow = changedStartIndex > 0 ? destRows[changedStartIndex - 1] : null;
    const previousSortKey = Number(previousRow?.sortKey || 0);

    const changeSort = [];

    for (let index = 0; index < changedRows.length; index++) {
        const row = changedRows[index];
        const newSortNumber = previousSortKey + index + 1;
        const currentSortKey = Number(row?.sortKey || 0);

        if (currentSortKey !== 0 && currentSortKey === newSortNumber) {
            break;
        }

        changeSort.push({
            dtid: row?.dtid || 0,
            did: row?.did || 0,
            sortNumber: newSortNumber
        });
    }

    const changePlanDate = [];
    if (dropResult.sourceRow.isGroupChanged) {
        const targetWeek = (weeks || []).find((week) => week.groupKey === dropResult.sourceRow.newWeekKey);

        if (targetWeek) {
            let planDate = formatIsoDate(targetWeek.weekEndDate);

            if (snapMode === 'first_date') {
                planDate = formatIsoDate(targetWeek.weekStartDate);
            }

            changePlanDate.push({
                dtid: dropResult.sourceRow.docTypeId || 0,
                did: dropResult.sourceRow.docId || 0,
                planDate
            });
        }
    }

    return {
        changeSort,
        changePlanDate
    };
};

export const applyPlanWeekLocalChanges = (groupData, dropResult, changePayload) => {
    if (!groupData || !dropResult?.sourceRow?.rowKey) {
        return groupData;
    }

    const updatedGroupData = { ...groupData };
    const movedRowKey = dropResult.sourceRow.rowKey;
    const movedGroupKey = dropResult.sourceRow.newGroupKey || dropResult.sourceRow.groupKey;
    const movedGroup = updatedGroupData.viewRows?.[movedGroupKey];
    const movedRow = movedGroup?.rowValues?.matchedData?.childRows?.[movedRowKey];
    const nextPlanFinishDate = changePayload?.changePlanDate?.[0]?.planDate || '';

    if (movedRow && nextPlanFinishDate) {
        movedRow.planFinishDate = nextPlanFinishDate;
    }

    return updatedGroupData;
};

export const applyPlanDateMoveLocalChanges = (groupData, weeks, changePlanDate) => {
    if (!groupData || !changePlanDate?.dtid || !changePlanDate?.did || !changePlanDate?.planDate) {
        return groupData;
    }

    const targetDate = new Date(`${changePlanDate.planDate}T00:00:00`);
    if (Number.isNaN(targetDate.getTime())) {
        return groupData;
    }

    const targetWeek = (weeks || []).find((week) => targetDate >= week.weekStartDate && targetDate <= week.weekEndDate);
    if (!targetWeek) {
        return groupData;
    }

    const rowKey = `${changePlanDate.did}`;
    let sourceGroupKey = '';
    let movedRow = null;

    (groupData.ViewRowsKeys || []).some((groupKey) => {
        const weekRow = groupData.viewRows?.[groupKey];
        const sourceRow = weekRow?.rowValues?.matchedData?.childRows?.[rowKey];

        if (sourceRow && Number(sourceRow?.dtid || 0) === Number(changePlanDate.dtid)) {
            sourceGroupKey = groupKey;
            movedRow = sourceRow;
            return true;
        }

        return false;
    });

    if (!sourceGroupKey || !movedRow) {
        return groupData;
    }

    const targetGroupKey = targetWeek.groupKey;
    const sourceGroup = groupData.viewRows?.[sourceGroupKey];
    const targetGroup = groupData.viewRows?.[targetGroupKey];

    if (!sourceGroup || !targetGroup) {
        return groupData;
    }

    const updatedRow = {
        ...movedRow,
        planFinishDate: changePlanDate.planDate
    };

    const updatedGroupData = {
        ...groupData,
        viewRows: {
            ...(groupData.viewRows || {})
        }
    };

    const sourceChildRows = {
        ...(sourceGroup.rowValues?.matchedData?.childRows || {})
    };
    const targetChildRows = sourceGroupKey === targetGroupKey
        ? sourceChildRows
        : { ...(targetGroup.rowValues?.matchedData?.childRows || {}) };

    sourceChildRows[rowKey] = updatedRow;

    const sourceChildRowKeys = [...(sourceGroup.rowValues?.matchedData?.ChildRowsKeys || [])];
    const targetChildRowKeys = sourceGroupKey === targetGroupKey
        ? sourceChildRowKeys
        : [...(targetGroup.rowValues?.matchedData?.ChildRowsKeys || [])];

    if (sourceGroupKey !== targetGroupKey) {
        delete sourceChildRows[rowKey];

        const sourceIndex = sourceChildRowKeys.indexOf(rowKey);
        if (sourceIndex >= 0) {
            sourceChildRowKeys.splice(sourceIndex, 1);
        }

        targetChildRows[rowKey] = updatedRow;

        if (!targetChildRowKeys.includes(rowKey)) {
            targetChildRowKeys.push(rowKey);
        }
    }

    updatedGroupData.viewRows[sourceGroupKey] = {
        ...sourceGroup,
        rowValues: {
            ...(sourceGroup.rowValues || {}),
            matchedData: {
                ...(sourceGroup.rowValues?.matchedData || {}),
                ChildRowsKeys: sourceChildRowKeys,
                childRows: sourceChildRows
            }
        }
    };

    if (sourceGroupKey !== targetGroupKey) {
        updatedGroupData.viewRows[targetGroupKey] = {
            ...targetGroup,
            rowValues: {
                ...(targetGroup.rowValues || {}),
                matchedData: {
                    ...(targetGroup.rowValues?.matchedData || {}),
                    ChildRowsKeys: targetChildRowKeys,
                    childRows: targetChildRows
                }
            }
        };
    }

    return updatedGroupData;
};

export const addDays = (date, days) => {
    const next = new Date(date);
    next.setDate(next.getDate() + days);
    return next;
};

export const addMonths = (date, months) => {
    const next = new Date(date);
    next.setMonth(next.getMonth() + months);
    return next;
};

export const startOfMonth = (date) => new Date(date.getFullYear(), date.getMonth(), 1);

export const endOfMonth = (date) => new Date(date.getFullYear(), date.getMonth() + 1, 0);

export const endOfWeek = (date) => {
    const next = new Date(date);
    const daysToSunday = 7 - (next.getDay() || 7);
    next.setDate(next.getDate() + daysToSunday);
    return next;
};

export const formatIsoDate = (date) => {
    const y = date.getFullYear();
    const m = `${date.getMonth() + 1}`.padStart(2, '0');
    const d = `${date.getDate()}`.padStart(2, '0');
    return `${y}-${m}-${d}`;
};

export const formatMonthKey = (date) => {
    const y = date.getFullYear();
    const m = `${date.getMonth() + 1}`.padStart(2, '0');
    return `${y}-${m}`;
};

export const formatMonthLabel = (date) => date.toLocaleString('en-US', { month: 'long', year: 'numeric' });

export const formatWeekLabel = (startDate, endDate) => {
    const startDay = startDate.getDate();
    const endDay = endDate.getDate();
    const endMonth = endDate.toLocaleString('en-US', { month: 'short' });

    return `${startDay}-${endDay} ${endMonth}`;
};

export const createWeek = (weekEndDate) => {
    const weekStartDate = addDays(weekEndDate, -6);

    return {
        groupKey: formatIsoDate(weekEndDate),
        weekStartDate,
        weekEndDate,
        weekLabel: formatWeekLabel(weekStartDate, weekEndDate),
        monthKey: formatMonthKey(weekEndDate),
        monthLabel: formatMonthLabel(weekEndDate),
        endDayLabel: weekEndDate.getDate().toString()
    };
};

export const buildCalendarWeeks = (baseDate) => {
    const rangeStart = startOfMonth(addMonths(baseDate, -MONTH_RANGE_BEFORE));
    const rangeEnd = endOfMonth(addMonths(baseDate, MONTH_RANGE_AFTER));

    const weeks = [];
    let weekEndDate = endOfWeek(rangeStart);
    const finalWeekEnd = endOfWeek(rangeEnd);

    while (weekEndDate <= finalWeekEnd) {
        weeks.push(createWeek(weekEndDate));
        weekEndDate = addDays(weekEndDate, 7);
    }

    return weeks;
};

export const buildMonthSpans = (weeks, currentMonthKey) => {
    const spans = [];
    let currentSpan = null;

    weeks.forEach((week, index) => {
        if (!currentSpan || currentSpan.monthKey !== week.monthKey) {
            currentSpan = {
                monthKey: week.monthKey,
                monthLabel: week.monthLabel,
                weekCount: 1,
                startIndex: index,
                isCurrentMonth: week.monthKey === currentMonthKey
            };
            spans.push(currentSpan);
        }
        else {
            currentSpan.weekCount += 1;
        }
    });

    return spans;
};

export const createWeekRow = (week) => ({
    rowKey: week.groupKey,
    rId: week.groupKey,
    viewKey: 'vCMNSearchCalendarWeekRow',
    sortKey: 0,
    dataList: {
        groupKey: week.groupKey,
        monthKey: week.monthKey,
        monthLabel: week.monthLabel,
        weekLabel: week.weekLabel,
        weekEndDate: week.groupKey,
        weekStartDate: formatIsoDate(week.weekStartDate)
    },
    rowValues: {
        groupTitle: { val: week.groupKey, valF: week.weekLabel },
        weekKey: { val: week.groupKey, valF: week.groupKey },
        weekLabel: { val: week.weekLabel, valF: week.weekLabel },
        weekEndDate: { val: week.groupKey, valF: week.groupKey },
        matchedData: {
            ChildRowsKeys: [],
            childRows: {}
        }
    }
});

const normalizeItemRow = (item) => {
    const rowKey = `${item?.did ?? item?.documentId ?? ''}`;

    return {
        ...item,
        rowKey,
        rId: item?.did ?? item?.documentId ?? 0,
        viewKey: item?.viewKey || '',
        sortKey: item?.sortKey || 0
    };
};

const sortWeekItemsBySortKey = (items) => (
    [...(items || [])].sort((itemA, itemB) => {
        const sortKeyA = Number(itemA?.sortKey || 0);
        const sortKeyB = Number(itemB?.sortKey || 0);

        if (sortKeyA !== sortKeyB) {
            return sortKeyA - sortKeyB;
        }

        const documentIdA = Number(itemA?.did ?? itemA?.documentId ?? 0);
        const documentIdB = Number(itemB?.did ?? itemB?.documentId ?? 0);

        return documentIdA - documentIdB;
    })
);

const buildServerWeekRows = (serverWeeks) => {
    const weekRows = {};

    (serverWeeks || []).forEach((week) => {
        const childRows = {};
        const childRowKeys = [];
        const sortedItems = sortWeekItemsBySortKey(week?.items);

        sortedItems.forEach((item) => {
            const normalizedItem = normalizeItemRow(item);
            if (!normalizedItem.rowKey) return;

            childRows[normalizedItem.rowKey] = normalizedItem;
            childRowKeys.push(normalizedItem.rowKey);
        });

        weekRows[week.weekKey] = {
            rowKey: week.weekKey,
            rId: week.weekKey,
            viewKey: 'vCMNSearchCalendarWeek',
            sortKey: 0,
            dataList: {
                groupKey: week.weekKey,
                weekLabel: week.weekLabel,
                weekEndDate: week.weekEndDate
            },
            rowValues: {
                groupTitle: { val: week.weekKey, valF: week.weekLabel },
                weekKey: { val: week.weekKey, valF: week.weekKey },
                weekLabel: { val: week.weekLabel, valF: week.weekLabel },
                weekEndDate: { val: week.weekEndDate, valF: week.weekEndDate },
                matchedData: {
                    ChildRowsKeys: childRowKeys,
                    childRows
                }
            }
        };
    });

    return weekRows;
};

const normalizeWeekRow = (serverWeekRow, generatedWeek) => {
    const generatedRow = createWeekRow(generatedWeek);

    if (!serverWeekRow) {
        return generatedRow;
    }

    return {
        ...generatedRow,
        ...serverWeekRow,
        rowKey: serverWeekRow.rowKey || generatedRow.rowKey,
        rId: serverWeekRow.rId || generatedRow.rId,
        viewKey: serverWeekRow.viewKey || generatedRow.viewKey,
        dataList: {
            ...generatedRow.dataList,
            ...(serverWeekRow.dataList || {}),
            groupKey: generatedWeek.groupKey,
            weekLabel: serverWeekRow?.rowValues?.weekLabel?.val || generatedWeek.weekLabel,
            weekEndDate: serverWeekRow?.rowValues?.weekEndDate?.val || generatedWeek.groupKey,
            weekStartDate: generatedRow.dataList.weekStartDate
        },
        rowValues: {
            ...generatedRow.rowValues,
            ...(serverWeekRow.rowValues || {}),
            groupTitle: {
                ...(generatedRow.rowValues.groupTitle || {}),
                ...(serverWeekRow?.rowValues?.groupTitle || {}),
                val: serverWeekRow?.rowValues?.weekKey?.val || generatedWeek.groupKey,
                valF: serverWeekRow?.rowValues?.weekLabel?.valF || serverWeekRow?.rowValues?.weekLabel?.val || generatedWeek.weekLabel
            },
            weekKey: {
                ...(generatedRow.rowValues.weekKey || {}),
                ...(serverWeekRow?.rowValues?.weekKey || {}),
                val: serverWeekRow?.rowValues?.weekKey?.val || generatedWeek.groupKey,
                valF: serverWeekRow?.rowValues?.weekKey?.valF || serverWeekRow?.rowValues?.weekKey?.val || generatedWeek.groupKey
            },
            weekLabel: {
                ...(generatedRow.rowValues.weekLabel || {}),
                ...(serverWeekRow?.rowValues?.weekLabel || {}),
                val: serverWeekRow?.rowValues?.weekLabel?.val || generatedWeek.weekLabel,
                valF: serverWeekRow?.rowValues?.weekLabel?.valF || serverWeekRow?.rowValues?.weekLabel?.val || generatedWeek.weekLabel
            },
            weekEndDate: {
                ...(generatedRow.rowValues.weekEndDate || {}),
                ...(serverWeekRow?.rowValues?.weekEndDate || {}),
                val: serverWeekRow?.rowValues?.weekEndDate?.val || generatedWeek.groupKey,
                valF: serverWeekRow?.rowValues?.weekEndDate?.valF || serverWeekRow?.rowValues?.weekEndDate?.val || generatedWeek.groupKey
            },
            matchedData: {
                ...(generatedRow.rowValues.matchedData || {}),
                ...(serverWeekRow?.rowValues?.matchedData || {}),
                ChildRowsKeys: serverWeekRow?.rowValues?.matchedData?.ChildRowsKeys || [],
                childRows: serverWeekRow?.rowValues?.matchedData?.childRows || {}
            }
        }
    };
};

export const mergeGroupData = (previousGroupData, weeks, serverWeekRows) => {
    const viewRows = {};
    const viewKeys = [];
    const hasServerRows = !!serverWeekRows;

    weeks.forEach((week) => {
        viewKeys.push(week.groupKey);
        const previousWeekRow = previousGroupData?.viewRows?.[week.groupKey];
        const serverWeekRow = serverWeekRows?.[week.groupKey];

        if (hasServerRows) {
            viewRows[week.groupKey] = normalizeWeekRow(serverWeekRow, week);
        }
        else if (previousWeekRow) {
            viewRows[week.groupKey] = previousWeekRow;
        }
        else {
            viewRows[week.groupKey] = normalizeWeekRow(serverWeekRow, week);
        }
    });

    return {
        ViewRowsKeys: viewKeys,
        viewRows
    };
};

export const extractServerWeekRows = (viewData) => {
    const serverWeeks = viewData?.childViewResponses?.itemView?.viewData?.weeks || [];
    return buildServerWeekRows(serverWeeks);
};

export const extendWeeks = (weeks, direction, count) => {
    if (!weeks || weeks.length === 0) return weeks;

    if (direction === 'left') {
        const firstEndDate = weeks[0].weekEndDate;
        const prependWeeks = [];

        for (let index = count; index >= 1; index -= 1) {
            prependWeeks.push(createWeek(addDays(firstEndDate, -(7 * index))));
        }

        return [...prependWeeks, ...weeks];
    }

    const lastEndDate = weeks[weeks.length - 1].weekEndDate;
    const appendWeeks = [];

    for (let index = 1; index <= count; index += 1) {
        appendWeeks.push(createWeek(addDays(lastEndDate, 7 * index)));
    }

    return [...weeks, ...appendWeeks];
};
